import React, { useState, useEffect } from "react";
import Header from "./header";
import { useLocation } from "react-router-dom";
// import Footer from "../components/footer";

const Frontend = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const [path, setPath] = useState("/");

  const location = useLocation();

  useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  return (
    <>
      <Header menuOpen={menuOpen} toggleMenu={toggleMenu} path={path} />
      {props.children}
      {/* <Footer /> */}
    </>
  );
};

export default Frontend;
